import Layout from '@/layout'

const aiRouter = {
  path: '/ai',
  name: 'AI',
  component: Layout,
  redirect: '/ai/chat',
  meta: { level: 1, cache: true },
  children: [
    {
      path: '/ai/chat',
      name: 'AiChat',
      component: () => import('@/views/ai/chat'),
      meta: { title: 'AI', icon: 'msg', iconActive: 'msg-active', cache: true, group: 'im' }
    }
  ]
}

export default aiRouter
